module.exports = __webpack_public_path__ + "img/2-stack.425adc71.png";